// src/components/atomic-crm/companies/CompanyAvatar.tsx
import { useEffect, useState } from "react";
import { useRecordContext } from "ra-core";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ds/ui/avatar";

import type { Company } from "../types";
import { getCompanyAvatar } from "../providers/commons/getCompanyAvatar";

export const CompanyAvatar = (props: {
  record?: Company;
  width?: 20 | 40;
  height?: 20 | 40;
}) => {
  const { width = 40 } = props;
  const record = useRecordContext<Company>(props);
  const [src, setSrc] = useState<string | null>(null);

  useEffect(() => {
    if (!record) {
      setSrc(null);
      return;
    }

    let cancelled = false;
    getCompanyAvatar(record).then((result) => {
      if (!cancelled) setSrc(result?.src ?? null);
    });

    return () => {
      cancelled = true;
    };
  }, [record]);

  if (!record) return null;

  const sizeClass = width !== 40 ? "w-[20px] h-[20px]" : "w-10 h-10";

  return (
    <Avatar className={sizeClass}>
      {src && (
        <AvatarImage src={src} alt={record.name} className="object-contain" />
      )}
      <AvatarFallback className={width !== 40 ? "text-xs" : "text-sm"}>
        {record.name?.charAt(0) || "?"}
      </AvatarFallback>
    </Avatar>
  );
};
